import React, { Component } from 'react';
import { Modal, Radio, message } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import addToDownloadSite from '../../../shared/addToDownloadSite';

const RadioGroup = Radio.Group;

class ExportModal extends Component {
    state = {
        visible: false,
    }

    show = () => {
        this.setState({
            exportType: '',
            visible: true,
        });
    }

    handleOk = () => {
        const { searchParams } = this.props;
        const { exportType } = this.state;
        if (exportType === '') {
            message.warning('请选择要导出内容');
            return;
        }

        const params = { exportType, ...searchParams };
        const url = API_URL.investigation.exportAllJde;

        if (exportType === 'finance') {
            addToDownloadSite (params, url, 'FINANCE_CONTRACT');
        } else if (exportType === 'singleHead') {
            addToDownloadSite (params, url, 'Contract_Single');
        } else if (exportType === 'multipleHead') {
            addToDownloadSite (params, url, 'Contract_Double');
        } else if (exportType === 'cashReqNode') {
            addToDownloadSite (params, url, 'Contract_Remittance_Node');
        } else if (exportType === 'rebateAmount') {
            addToDownloadSite (params, url, 'FINANCE_CONTRACT_REBATE');
        } else {
            $.sendRequest({
                method: 'POST',
                url: url,
                data: {
                    ...params,
                    offset: 1,
                },
                dataType: 'json',
                doneResult: res => {
                    message.success(res.success);
                },
            });
        }

        this.setState({ visible: false });
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    onChange = (e) => {
        this.setState({ exportType: e.target.value });
    }

    render() {
        const { visible, exportType } = this.state;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="500px"
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <div className="item" >
                        <label className="ui-label">请选择要导出内容 ：</label>
                    </div>
                    <div className="item">
                        <RadioGroup onChange={this.onChange} value={exportType}>
                            <div style={{ marginTop: 15 }}><Radio value="finance">项目合同汇总记录（财务版）</Radio></div>
                            <div style={{ marginTop: 15 }}><Radio value="rebateAmount">项目合同rebate费汇总记录（财务版）</Radio></div>
                            <div style={{ marginTop: 15 }}><Radio value="singleHead">项目合同汇总记录（单表头）</Radio></div>
                            <div style={{ marginTop: 15 }}><Radio value="multipleHead">项目合同汇总记录（双表头）</Radio></div>
                            <div style={{ marginTop: 15 }}><Radio value="cashReqNode">请款节点</Radio></div>
                            <div style={{ marginTop: 15 }}><Radio value="siteWithNotSignedJde">尚未关联合同的中心</Radio></div>
                            <div style={{ marginTop: 15 }}><Radio value="jdeNotSigned">合同尚未签署完成的项目清单</Radio></div>
                        </RadioGroup>
                    </div>
                </div>
            </Modal>
        )
    }
}

export default ExportModal;


// WEBPACK FOOTER //
// ./src/components/contractManagement/contractRecord/components/ExportModal.js